module.exports = __webpack_public_path__ + "e72b64e90440dd1a6793226d56318dff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/official-owlfonso.png
// module id = 299
// module chunks = 0